import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { apiUrl, baseUrl } from "../../../utils/apis";
import { BannerApiResponse } from "./types";






export const bannerApi = createApi({
  reducerPath: "bannerApi",
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers) => {
      const token = sessionStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["Banner"],

  endpoints: (builder) => ({
    // GET ALL BANNERS
    getBanners: builder.query<BannerApiResponse, void>({
      query: () => ({
        url: apiUrl.bannerApi, 
        method: "GET",
      }),
      providesTags: ["Banner"],
    }),

    getBannerById: builder.query<any, number>({
      query: (id) => ({
        url: `${apiUrl.bannerApi}${id}`,
        method: 'GET'
      }),
      
    }),

    // CREATE BANNER
    createBanner: builder.mutation<any, FormData>({
      query: (body) => ({
        url: apiUrl.bannerApi,
        method: "POST",
        body,
      }),
      invalidatesTags: ["Banner"],
    }),

    // UPDATE BANNER
    updateBanner: builder.mutation<any, { id: number; body: FormData }>({
      query: ({ id, body }) => ({
        url: `${apiUrl.bannerApi}${id}/`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Banner"],
    }),

    // DELETE BANNER
    deleteBanner: builder.mutation<any, number>({
      query: (id) => ({
        url: `${apiUrl.bannerApi}${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Banner"],
    }),
  }),
});



export const {
  useGetBannersQuery,
  useCreateBannerMutation,
  useUpdateBannerMutation,
  useDeleteBannerMutation,
  useGetBannerByIdQuery
} = bannerApi;
